// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__PTTi5","footer":"ModalUpdate_footer__3xKXo"};